import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';

// React Redux
import { connect } from 'react-redux';
import { setLoaderStart, setLoaderComplete } from '../../../../actions/loader/loader';

import withStyles from 'isomorphic-style-loader/withStyles';

// Locale
import messages from '../../../../locale/jsonMessages';
import { deleteFavIcon, updateFaviconLogo } from '../../../../actions/siteadmin/manageLogo';
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';
import { photosShow } from '../../../../helpers/photosShow';
import { faviconUploadDir } from '../../../../config';
import { withQuery } from '../../../../hoc/withGraphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import s from './FavIconUploader.css';
import cs from '../../../../components/commonStyle.css';

class FavIconUploader extends React.Component {

    static propTypes = {
        favIconLoader: PropTypes.bool,
        data: PropTypes.object
    };

    static defaultProps = {
        favIconLoader: false
    };

    success = async (file, fromServer) => {
        const { updateFaviconLogo, data: { getSiteSettingsLogo }, setLoaderStart, setLoaderComplete, demoRestriction } = this.props;
        let fileName = fromServer.file.filename,
            oldPicture = getSiteSettingsLogo ? getSiteSettingsLogo.value : null;
        const isRestrict = await demoRestriction({});
        if (isRestrict) return;
        await setLoaderStart('favIconLoader');
        await updateFaviconLogo('Favicon Logo', 'faviconLogo', fileName, oldPicture);
        await setLoaderComplete('favIconLoader');
    }

    render() {
        const { favIconLoader, data: { loading, getSiteSettingsLogo = {} }, faviconLogo, deleteFavIcon } = this.props;
        const { formatMessage } = this.props.intl;
        let path = photosShow(faviconUploadDir);

        return (
            <div>
                <CommonImageDisplay
                    loading={loading}
                    image={getSiteSettingsLogo?.value && path + getSiteSettingsLogo?.value}
                    isDefaultPic={getSiteSettingsLogo?.value ? false : true}
                    loader={favIconLoader}
                    isDelete={false}
                />
                <ImageUploadComponent
                    defaultMessage={formatMessage(messages.clickHeretoUploadLogo)}
                    componentConfig={{
                        iconFiletypes: ['.png'],
                        multiple: false,
                        showFiletypeIcon: false,
                        postUrl: '/uploadFavIcon'
                    }}
                    loaderName={'favIconLoader'}
                    success={this.success}
                    getSiteSettingsLogo={getSiteSettingsLogo}
                    className={cs.spaceTop3}
                />
            </div>
        );
    }
}

const mapState = (state) => ({
    favIconLoader: state.loader.favIconLoader
});

const mapDispatch = {
    deleteFavIcon,
    updateFaviconLogo,
    setLoaderStart,
    setLoaderComplete,
    demoRestriction
};

export default compose(
    injectIntl,
    withStyles(s, cs),
    connect(mapState, mapDispatch),
    withQuery(gql`
                    query getSiteSettingsLogo($title: String!, $name: String!) {
                        getSiteSettingsLogo(title:$title, name: $name) {
                        status
                errorMessage
                    title
                    name
                    value
            }
        }
                    `, {
        options: {
            ssr: false,
            variables: {
                title: 'Favicon Logo',
                name: 'faviconLogo'
            }
        }
    }),
)(FavIconUploader);